module.exports = __webpack_public_path__ + "media/fastweb_volunteers/DS_logo_FW-350x242-3b2d3caf.jpeg";